import React from 'react';
import { 
	func, 
} from 'prop-types';

function swap(a,x,y){
	a[x]=[a[y],a[y]=a[x]][0];
	return a;
}

export default class Container extends React.PureComponent {
	static propTypes = {
		render : func.isRequired,
		onSort : func.isRequired
	}

	constructor(props) {
		super(props);
		const {values} = props;
		const indices = [...Array(values.length)].map((_,i)=>i);
		this.state={
			indices
    	};
	}
	
	render(){
		const {render,onSort,...other} = this.props;
        
		return render({
			onUp : (index)=>()=>{
				if(index>0){
					const newIndices = swap(this.state.indices, index,index-1);
					this.setState({
						indices : newIndices
					});
					onSort(newIndices);
				}
			},
			onDown : (index)=>()=>{
				const length = this.state.indices.length;
				if(length-1>index){
					const newIndices = swap(this.state.indices, index,index+1);
					this.setState({
						indices : newIndices
					});
					onSort(newIndices);
				}
			}
		},other);
	}
}
